/* Dust & Mile cart discount code box (snippets/dm-cart-discount), ported from Conquering Barbell.
   Codes go onto the cart through /cart/update.js ("discount" takes the full comma-separated list), so the
   savings show in the drawer and on /cart and carry into checkout. A newly entered code that doesn't apply
   is taken back off; one that stops applying later stays listed as "not applied".
   The drawer and /cart are server-rendered, so after a change both are re-rendered; a MutationObserver
   puts the message and applied-code chips back into the fresh boxes. */
(function () {
  if (window.dmDiscount) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var codes = [];
  var pending = null; // { id, text, kind } shown in the box with that input id after the re-render

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function setMsg(box, text, kind) {
    var msg = box && box.querySelector('[data-dm-discount-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = 'dm-discount__msg' + (kind ? ' dm-discount__msg--' + kind : '');
    msg.hidden = !text;
  }

  function renderCodes() {
    document.querySelectorAll('[data-dm-discount-codes]').forEach(function (list) {
      list.innerHTML = '';
      codes.forEach(function (d) {
        var li = document.createElement('li');
        li.className = 'dm-discount__code' + (d.applicable ? '' : ' is-inactive');
        var name = document.createElement('span');
        name.textContent = d.code + (d.applicable ? '' : ' (not applied)');
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'dm-discount__remove';
        rm.setAttribute('data-dm-discount-remove', d.code);
        rm.setAttribute('aria-label', 'Remove code ' + d.code);
        rm.textContent = '×';
        li.appendChild(name);
        li.appendChild(rm);
        list.appendChild(li);
      });
      list.hidden = codes.length === 0;
    });
  }

  function loadCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { codes = cart.discount_codes || []; renderCodes(); return cart; })
      .catch(function () {});
  }

  function post(list) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      return r.json();
    });
  }

  function rerender() {
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();
    var page = document.querySelector('dm-cart-page');
    if (page && typeof page.refresh === 'function') page.refresh();
  }

  function send(list, box, tried) {
    var btn = box && box.querySelector('[data-dm-discount-apply]');
    var inputId = box && box.querySelector('[data-dm-discount-input]') ? box.querySelector('[data-dm-discount-input]').id : null;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var missed = false;
    return post(list)
      .then(function (cart) {
        if (!tried) return cart;
        var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === tried; })[0];
        if (hit && hit.applicable) return cart;
        // A mistyped or ineligible code would otherwise sit on the cart and follow the shopper into checkout
        missed = true;
        return post(list.filter(function (c) { return c !== tried; }));
      })
      .then(function (cart) {
        codes = cart.discount_codes || [];
        if (tried && missed) {
          pending = { at: Date.now(), id: inputId, text: tried + ' can’t be used on the items in your cart. Check the code and try again.', kind: 'error' };
        } else if (tried) {
          pending = { at: Date.now(), id: inputId, text: tried + ' applied. You’re saving ' + money(cart.total_discount) + '.', kind: 'ok' };
        }
        setMsg(box, pending && pending.text, pending && pending.kind);
        renderCodes();
        rerender();
        return cart;
      })
      .catch(function () {
        setMsg(box, 'Couldn’t reach the cart. Check your connection and try again.', 'error');
      })
      .then(function (cart) {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        return cart;
      });
  }

  function apply(box) {
    if (!box) return;
    var input = box.querySelector('[data-dm-discount-input]');
    var code = input ? input.value.trim().toUpperCase() : '';
    if (!code) {
      setMsg(box, 'Enter a discount code first.', 'error');
      if (input) input.focus();
      return;
    }
    var list = codes.map(function (d) { return d.code; }).filter(function (c) { return c.toUpperCase() !== code; });
    list.push(code);
    send(list, box, code);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-dm-discount-apply]');
    if (a) { e.preventDefault(); apply(a.closest('[data-dm-discount]')); return; }
    var rm = e.target.closest && e.target.closest('[data-dm-discount-remove]');
    if (rm) {
      e.preventDefault();
      var gone = rm.getAttribute('data-dm-discount-remove');
      var box = rm.closest('[data-dm-discount]');
      pending = { at: Date.now(), id: box && box.querySelector('[data-dm-discount-input]') ? box.querySelector('[data-dm-discount-input]').id : null, text: gone + ' removed.', kind: '' };
      send(codes.map(function (d) { return d.code; }).filter(function (c) { return c !== gone; }), box, null);
    }
  });

  // Enter applies the code instead of submitting the cart form (which goes to checkout)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-dm-discount-input]')) return;
    e.preventDefault();
    apply(e.target.closest('[data-dm-discount]'));
  });

  // Re-renders replace the boxes: put the chips back and show the last message once in the matching box
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    // a timer, not requestAnimationFrame: frames pause in background tabs and would leave this stuck
    setTimeout(function () {
      queued = false;
      var fresh = document.querySelectorAll('[data-dm-discount]:not([data-dm-ready])');
      if (!fresh.length) return;
      fresh.forEach(function (box) {
        box.setAttribute('data-dm-ready', '');
        var input = box.querySelector('[data-dm-discount-input]');
        // The drawer can re-render more than once per change, so the message stays pending for a few seconds
        if (pending && input && input.id === pending.id && Date.now() - pending.at < 6000) {
          setMsg(box, pending.text, pending.kind);
        }
      });
      loadCart();
    }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.querySelectorAll('[data-dm-discount]').forEach(function (b) { b.setAttribute('data-dm-ready', ''); });
  loadCart();

  window.dmDiscount = { refresh: loadCart };
})();
